import(/* webpackMode: "eager" */ "/app/src/app/(lyk-appp)/(sidebar)/watchlist/page.tsx")